import { render, staticRenderFns } from "./TableViewHead.vue?vue&type=template&id=4dbec011&scoped=true"
import script from "./TableViewHead.vue?vue&type=script&lang=js"
export * from "./TableViewHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbec011",
  null
  
)

export default component.exports